import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { CloseButton } from "../CloseButton";
import { MIN_WIDTH } from "../../consts/modals";
import { Text } from "../Base";
import { makeStyles } from "@mui/styles";
import { palette } from "../../theme/palette";

const useStyles = makeStyles((theme) => ({
  container: {
    marginLeft: (props) => theme.typography.pxToRem(props.offsetLeft),
    minWidth: (props) => theme.typography.pxToRem(props.minWidth),
  },
  title: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "18px",
    backgroundColor: palette.dpdLightGrey,
  },
}));

export const Modal = ({
  title,
  content,
  actions,
  open,
  onClose,
  minWidth = MIN_WIDTH,
  width = MIN_WIDTH,
  offsetLeft = 0,
  maxWidth = false,
}) => {
  const styles = useStyles({ minWidth, width, offsetLeft });

  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Dialog
      className={styles.container}
      open={!!open}
      onClose={handleClose}
      PaperProps={{ className: styles.container }}
      maxWidth={maxWidth}
    >
      <DialogTitle className={styles.title}>
        <Text>{typeof title === "string" && title.toUpperCase()}</Text>
        <CloseButton onClose={handleClose} />
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
};
